import { ArchiveMutation } from "../../hooks/useArchiveState";
import {
  PatientPortalEmailControllerApi
} from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 *
 * @author [Atish Bagate]
 */
export const useArchiveEmail = () =>
  useMutationWithLoading(async (param: ArchiveMutation) =>
    new PatientPortalEmailControllerApi(
      getConfigObject()
    ).archivePatientPortalEmail(
      param.status,
      [param.id],
      param.xTENANTID //xTENANTID
    )
  );
